import { connect } from 'react-redux';

import Sign from '../../views/Sign';

const mapStateToProps = state => ({
  signLinkMember1: state.application.currentApplicant.members.member1.signLink,
  signLinkMember2: state.application.showMember2
    ? state.application.currentApplicant.members.member2.signLink
    : null,
  nameMember1: state.application.currentApplicant.members.member1.name,
  nameMember2: state.application.showMember2
    ? state.application.currentApplicant.members.member2.name
    : null,
});

export default connect(mapStateToProps)(Sign);



// WEBPACK FOOTER //
// ./src/features/Sign/index.js